import { toCamelCase } from '@packages/shared/utils';

/**
 * Known automation semantic IDs for import/export toolbar controls.
 * Use these in V2 schema `semanticId` fields when migrating legacy pages.
 *
 * Legacy ImportBlock derived file input ids from `toCamelCase(option.title)`.
 * Most pages match these constants automatically; set explicit `semanticId` when
 * automation maps use a different id (e.g. participant-specific imports).
 */
export const IMPORT_EXPORT_SEMANTIC_IDS = {
  downloadTemplate: 'downloadTemplate',
  importTemplate: 'importTemplate',
  importBulkXls: 'importBulkXls',
  importBulkParticipantXls: 'importBulkParticipantXls',
  importBulkYtdXls: 'importBulkYtdXls',
} as const;

/**
 * Resolves DOM id for import/export toolbar triggers and file inputs.
 * Priority: explicit schema semanticId → toCamelCase(label) (legacy ImportBlock behavior).
 */
export function resolveImportExportSemanticId(
  explicit: string | null | undefined,
  label: string,
): string | undefined {
  if (explicit) return explicit;
  const derived = toCamelCase(label);
  return derived || undefined;
}

/**
 * Resolves DOM id for hidden file inputs in import/export toolbars.
 * Priority: explicit semanticId → toCamelCase(label) → fallback index id (legacy ImportBlock).
 */
export function resolveImportExportFileInputId(
  explicit: string | null | undefined,
  label: string,
  groupIndex: number,
  optionIndex: number,
): string {
  if (explicit) return explicit;
  const derived = toCamelCase(label);
  return derived || `my-file-${groupIndex}-${optionIndex}`;
}
